import { type ComponentPropsWithRef, useEffect, useMemo, useRef, useState } from "react"

import cssModule from "./index.module.scss"
import { cx } from "classix"

export type CollapsableProps = {
	open?: boolean
} & ComponentPropsWithRef<"div">

/**
 * Для отображения скрываемого контента
 */
export const Collapsable = 	function Collapsable({ open, children, style, className, ...props }: CollapsableProps) {
	const [height, setHeight] = useState(0)

	const resizeObserver = useMemo(
		() =>
			new ResizeObserver((entries) => {
				const target = entries[0].target as HTMLDivElement
				const targetHeight = target.offsetHeight
				setHeight(targetHeight)
			}),
		[]
	)

	const innerRef = useRef<HTMLDivElement>(null)

	useEffect(() => {
		if (innerRef.current) {
			resizeObserver.observe(innerRef.current)
			const el = innerRef.current
			return () => resizeObserver.unobserve(el)
		}

		return

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	return (
		<div
			className={cx(cssModule.root, className)}
			style={{ height: open ? height + "px" : "0", ...style }}
			{...props}>
			<div ref={innerRef} className="w-[100%]">
				{children}
			</div>
		</div>
	)
}

Collapsable.displayName = "Collapsable"
